<template>
  <div style="padding: 00px">
    <div style="margin: 0 0 20px; font-size: 20px">你好，{{ name }}！</div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-form-item label="原密码" prop="oldpwd">
        <el-input v-model="ruleForm.oldpwd" class="inputh" style="width: 220px" show-password placeholder="请输入您的原密码"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newpwd">
        <el-input v-model="ruleForm.newpwd" class="inputh" style="width: 220px" show-password placeholder="请输入您的新密码"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="repeat">
        <el-input v-model="ruleForm.repeat" class="inputh" style="width: 220px" show-password placeholder="请重复您的新密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm()" size="small">修改密码</el-button>
        <el-button @click="resetForm()" size="small">重置表单</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { changePassword } from '@/api/home'
export default {
  data() {
    let reg = /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{6,12}$/
    var newPass = (rule, value, callback) => {
      if (!reg.test(value)) {
        callback(new Error('密码应是6-12位，至少包含数字、字母或字符的两种！'))
      } else if (this.ruleForm.oldpwd === value) {
        callback(new Error('新密码与旧密码不可一致！'))
      } else {
        callback()
      }
    }
    var repeatPass = (rule, value, callback) => {
      if (this.ruleForm.newpwd !== value) {
        callback(new Error('两次密码不一致！'))
      } else if (!reg.test(value)) {
        callback(new Error('密码应是6-12位，至少包含数字、字母或字符的两种！'))
      } else {
        callback()
      }
    }
    return {
      name: '',
      loading: false,
      ruleForm: {
        oldpwd: '',
        newpwd: '',
        repeat: ''
      },
      rules: {
        oldpwd: [
          {
            required: true,
            message: '请输入原密码',
            trigger: 'blur'
          },
          { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' } //长度
        ],
        newpwd: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          },
          { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }, //长度

          { validator: newPass, trigger: 'blur' }
        ],
        repeat: [
          {
            required: true,
            message: '两次密码不一样',
            trigger: 'blur'
          },
          { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }, //长度
          { validator: repeatPass, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    resetForm() {
      this.ruleForm = {
        oldpwd: '',
        newpwd: '',
        repeat: ''
      }
    },
    submitForm() {
      const params = {
        oldPassword: this.ruleForm.oldpwd,
        newPassword: this.ruleForm.newpwd
      }
      changePassword(params).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('密码修改成功!')
          this.resetForm()
        }
      })
    }
  },
  mounted() {
    this.name = JSON.parse(localStorage.getItem('info')).teacher.name
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/password/index.vue